import React, { Component } from 'react';
import { bool, object } from 'prop-types';
import { connect } from 'react-redux';

import NotebookViews from './views';


class Notebook extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { isMobile, isShown, highlights } = this.props;

    if (!isShown) {
      return null;
    }

    const viewProps = {
      isMobile,
      styles: {
        height: `${window.innerHeight - 54}px`
      },
      highlights
    };

    return <NotebookViews { ...viewProps } />;
  }
}

Notebook.propTypes = {
  isMobile: bool.isRequired,
  isShown: bool.isRequired
};

function mapStateToProp(state) {
  const { reader: { isMobile }, highlights } = state;

  return {
    highlights,
    isMobile
  };
}


export default connect(mapStateToProp)(Notebook);
